import { BUILDING } from '@/interfaces/building.interface'
import { COMPLEX } from '@/interfaces/complex.interface'
import { REAL_ESTATE } from '@/interfaces/realEstate.interface'
import mapboxgl from 'mapbox-gl'

export function getBoundsForCoordinates(coordinates) {
  const bounds = coordinates.reduce(function (bounds, coord) {
    return bounds.extend(coord)
  }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]))
  return bounds
}
export function getBuildingCoordinates(
  selectedComplex: COMPLEX | undefined,
  buildings: BUILDING[]
) {
  let buildingsWithGeometry = buildings.filter((building) => building.geometry)
  if (selectedComplex)
    buildingsWithGeometry = buildingsWithGeometry.filter(
      (building) => selectedComplex.properties.belongsToId === building.properties.complexId
    )
  if (!buildingsWithGeometry.length && selectedComplex) {
    const coordinates: [number, number][] = [
      [selectedComplex.geometry.coordinates[0], selectedComplex.geometry.coordinates[1]]
    ]
    return coordinates
  }
  const coordinates: [number, number][] = []
  buildingsWithGeometry.forEach((building) => {
    building.geometry.coordinates[0].forEach((coordinate) => {
      if (building.geometry.type === 'Polygon') {
        coordinates.push(coordinate)
      } else {
        // Building geometry can be of type 'MultiPolygon'
        coordinates.push(coordinate[0])
      }
    })
  })
  return coordinates
}
export function getBuildingCoordinatesForRealEstate(realEstateId, buildings: BUILDING[]) {
  const buildingsWithGeometry = buildings.filter((building) => building.geometry)
  const featuredBuildings: BUILDING[] = []
  const coordinates: [number, number][] = []
  if (realEstateId) {
    const foundBuildings = buildingsWithGeometry.filter(
      (building) => building.properties.realEstateId === realEstateId
    )
    featuredBuildings.push(...foundBuildings)
  }
  featuredBuildings.forEach((building) => {
    building.geometry.coordinates[0].forEach((coordinate) => {
      if (building.geometry.type === 'Polygon') {
        coordinates.push(coordinate)
      } else {
        // Building geometry can be of type 'MultiPolygon'
        coordinates.push(coordinate[0])
      }
    })
  })
  return coordinates
}
export function getBuildingsCoordinatesRealEstateOptions(
  realEstateIds: string[],
  buildings: BUILDING[]
) {
  const buildingsForRealEstateOptions: BUILDING[] = []
  realEstateIds.forEach((id) => {
    if (id === 'undefined') return
    const relatedBuildings = buildings.filter((building) => id === building.properties.realEstateId)
    buildingsForRealEstateOptions.push(...relatedBuildings)
  })
  const coordinates: [number, number][] = []
  buildingsForRealEstateOptions.forEach((building) => {
    building.geometry.coordinates[0].forEach((coordinate) => {
      if (building.geometry.type === 'Polygon') {
        coordinates.push(coordinate)
      } else {
        // Building geometry can be of type 'MultiPolygon'
        coordinates.push(coordinate[0])
      }
    })
  })
  return coordinates
}
export function getCoordinatesForComplex(complexId, complexCoordinates, allBuildingsSource) {
  const coordinates: [number, number][] = []
  const allBuildings = allBuildingsSource._data.features
  const buildingsForComplex = allBuildings.filter(
    (buildings) => complexId === buildings.properties.complexId
  )
  // Zoom to complex coordinate if the related building(s) lack geometry information
  if (!buildingsForComplex.length) return [complexCoordinates[0], complexCoordinates[1]]
  if (buildingsForComplex.some((building) => building.geometry)) {
    const buildingsWithGeometry = buildingsForComplex.filter((el) => el.geometry)
    buildingsWithGeometry.forEach((building) => {
      if (!building.geometry) return
      building.geometry.coordinates[0].forEach((coordinate) => {
        if (building.geometry.type === 'Polygon') {
          coordinates.push(coordinate)
        } else {
          // Building geometry can be of type 'MultiPolygon'
          coordinates.push(coordinate[0])
        }
      })
    })
  }
  return coordinates
}
export function getCoordinatesForRealEstate(realEstate: REAL_ESTATE, buildings: BUILDING[]) {
  buildings = buildings.filter((building) => realEstate.id === building.properties.realEstateId)
  const coordinates: [number, number][] = []
  if (realEstate.properties.location?.coordinates.length) {
    const realEstateCoordinates = realEstate.properties.location.coordinates
    coordinates.push([realEstateCoordinates[0], realEstateCoordinates[1]])
    return coordinates
  }
  // Using related building coordinates if real estate location is missing
  buildings.forEach((building) => {
    building.geometry.coordinates[0].forEach((coordinate) => {
      if (building.geometry.type === 'Polygon') {
        coordinates.push(coordinate)
      } else {
        // Building geometry can be of type 'MultiPolygon'
        coordinates.push(coordinate[0])
      }
    })
  })
  return coordinates
}
